enum localStorageEnum {
	accessToken = 'accessToken',
	informationsUtilisateur = 'informationsUtilisateur'
}

export default localStorageEnum
